// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Base$MakerDs from "maker-ds/src/Base.bs.mjs";
import * as ReactPortal from "react-portal";
import * as Modal$MakerDs from "maker-ds/src/Modal.bs.mjs";
import * as Table$MakerDs from "maker-ds/src/Table.bs.mjs";
import * as Button$MakerDs from "maker-ds/src/Button.bs.mjs";
import * as Product$FeedSync from "../models/Product.bs.mjs";

function getFields(product) {
  var validated;
  if (product.TAG === /* Accepted */0) {
    validated = product._1;
  } else {
    var validated$1 = product._1;
    validated = validated$1 !== undefined ? validated$1 : undefined;
  }
  var getCustomLabelContents = function (prefixOpt, customLabel) {
    var prefix = prefixOpt !== undefined ? prefixOpt : "";
    var match = customLabel.finalValue;
    if (match.TAG !== /* Ok */0) {
      return [];
    }
    var value = match._0;
    if (value !== undefined) {
      return [
              [
                "" + prefix + "created_at",
                Product$FeedSync.Validation.mapFinalValue(value.x_created_at, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "best_seller_rank",
                Product$FeedSync.Validation.mapFinalValue(value.x_best_seller_rank, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "featured_rank",
                Product$FeedSync.Validation.mapFinalValue(value.x_featured_rank, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "reviews_average",
                Product$FeedSync.Validation.mapFinalValue(value.x_reviews_average, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "reviews_count",
                Product$FeedSync.Validation.mapFinalValue(value.x_reviews_count, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "promo_text",
                Product$FeedSync.Validation.mapFinalValue(value.x_promo_text, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "tags",
                Product$FeedSync.Validation.mapFinalValue(value.x_tags, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "quantity",
                Product$FeedSync.Validation.mapFinalValue(value.x_quantity, (function (param) {
                        return "";
                      }))
              ],
              [
                "" + prefix + "meta",
                {
                  initialValue: Belt_Option.flatMap(value.x_meta, (function (prim) {
                          return JSON.stringify(prim);
                        })),
                  finalValue: {
                    TAG: /* Ok */0,
                    _0: ""
                  },
                  warnings: []
                }
              ],
              [
                "" + prefix + "options",
                {
                  initialValue: Belt_Option.flatMap(value.x_options, (function (prim) {
                          return JSON.stringify(prim);
                        })),
                  finalValue: {
                    TAG: /* Ok */0,
                    _0: ""
                  },
                  warnings: []
                }
              ]
            ];
    } else {
      return [];
    }
  };
  if (validated !== undefined) {
    return Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat([
                                                                                                [
                                                                                                  "id",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.google_feed_id, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "title",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.title, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "size",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.size, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "color",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.color, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "pattern",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.pattern, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "material",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.material, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "style",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.style, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "price",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.price, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "sale_price",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.sale_price, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "description",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.description, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "item_group_id",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.item_group_id, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "image_link",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.image_link, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "additional_image_link",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.additional_image_link, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "google_product_category",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.google_product_category, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "product_type",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.product_type, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "availability",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.availability, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "link",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.link, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "brand",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.brand, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "mpn",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.mpn, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ],
                                                                                                [
                                                                                                  "sku",
                                                                                                  Product$FeedSync.Validation.mapFinalValue(validated.sku, (function (param) {
                                                                                                          return "";
                                                                                                        }))
                                                                                                ]
                                                                                              ], getCustomLabelContents(undefined, validated.extensions)), [[
                                                                                              "custom_label_0",
                                                                                              Product$FeedSync.Validation.mapFinalValue(validated.custom_label_0, (function (param) {
                                                                                                      return "";
                                                                                                    }))
                                                                                            ]]), getCustomLabelContents("...", validated.custom_label_0)), [[
                                                                                      "custom_label_1",
                                                                                      Product$FeedSync.Validation.mapFinalValue(validated.custom_label_1, (function (param) {
                                                                                              return "";
                                                                                            }))
                                                                                    ]]), getCustomLabelContents("...", validated.custom_label_1)), [[
                                                                              "custom_label_2",
                                                                              Product$FeedSync.Validation.mapFinalValue(validated.custom_label_2, (function (param) {
                                                                                      return "";
                                                                                    }))
                                                                            ]]), getCustomLabelContents("...", validated.custom_label_2)), [[
                                                                      "custom_label_3",
                                                                      Product$FeedSync.Validation.mapFinalValue(validated.custom_label_3, (function (param) {
                                                                              return "";
                                                                            }))
                                                                    ]]), getCustomLabelContents("...", validated.custom_label_3)), [[
                                                              "custom_label_4",
                                                              Product$FeedSync.Validation.mapFinalValue(validated.custom_label_4, (function (param) {
                                                                      return "";
                                                                    }))
                                                            ]]), getCustomLabelContents("...", validated.custom_label_4)), [[
                                                      "custom_label_5",
                                                      Product$FeedSync.Validation.mapFinalValue(validated.custom_label_5, (function (param) {
                                                              return "";
                                                            }))
                                                    ]]), getCustomLabelContents("...", validated.custom_label_5)), [[
                                              "custom_label_6",
                                              Product$FeedSync.Validation.mapFinalValue(validated.custom_label_6, (function (param) {
                                                      return "";
                                                    }))
                                            ]]), getCustomLabelContents("...", validated.custom_label_6)), [[
                                      "custom_label_7",
                                      Product$FeedSync.Validation.mapFinalValue(validated.custom_label_7, (function (param) {
                                              return "";
                                            }))
                                    ]]), getCustomLabelContents("...", validated.custom_label_7)), [[
                              "custom_label_8",
                              Product$FeedSync.Validation.mapFinalValue(validated.custom_label_8, (function (param) {
                                      return "";
                                    }))
                            ]]), getCustomLabelContents("...", validated.custom_label_8)), [[
                      "custom_label_9",
                      Product$FeedSync.Validation.mapFinalValue(validated.custom_label_9, (function (param) {
                              return "";
                            }))
                    ]]), getCustomLabelContents("...", validated.custom_label_9));
  } else {
    return [];
  }
}

function ProductTable$Validation$FieldSummary(Props) {
  var product = Props.product;
  var getField = Props.getField;
  var detailsOpt = Props.details;
  var details = detailsOpt !== undefined ? detailsOpt : false;
  var validated;
  if (product.TAG === /* Accepted */0) {
    validated = product._1;
  } else {
    var validated$1 = product._1;
    validated = validated$1 !== undefined ? validated$1 : undefined;
  }
  if (validated === undefined) {
    return React.createElement("div", undefined, "--");
  }
  var field = Curry._1(getField, validated);
  var result = Belt_Option.getWithDefault(field.initialValue, "--");
  var error = field.finalValue;
  var tmp;
  tmp = error.TAG === /* Ok */0 ? result : React.createElement("div", {
          className: CSS$MakerDs.prefix("text-red-600")
        }, result, React.createElement("div", {
              className: CSS$MakerDs.prefix("text-xs")
            }, details ? "Error: " + error._0 + "" : "Error"));
  var match = field.warnings;
  return React.createElement(React.Fragment, undefined, tmp, details ? Belt_Array.map(field.warnings, (function (warning) {
                      return React.createElement("div", {
                                  className: CSS$MakerDs.prefix("text-xs text-yellow-500")
                                }, "Warning: " + warning + "");
                    })) : (
                match.length !== 0 ? React.createElement("div", {
                        className: CSS$MakerDs.prefix("text-xs text-yellow-500")
                      }, "Warning") : null
              ));
}

var FieldSummary = {
  make: ProductTable$Validation$FieldSummary
};

function ProductTable$Validation$ProductSummary(Props) {
  var product = Props.product;
  var warnings = Belt_Array.reduce(getFields(product), [], (function (acc, param) {
          return Belt_Array.concat(acc, param[1].warnings);
        }));
  if (product.TAG === /* Accepted */0) {
    if (warnings.length !== 0) {
      return React.createElement("div", {
                  className: CSS$MakerDs.prefix("text-yellow-500")
                }, "Valid with warnings");
    } else {
      return React.createElement("div", {
                  className: CSS$MakerDs.prefix("text-green-900")
                }, "Valid");
    }
  } else {
    return React.createElement("div", {
                className: CSS$MakerDs.prefix("text-red-600")
              }, "Error: " + product._0 + "");
  }
}

var ProductSummary = {
  make: ProductTable$Validation$ProductSummary
};

var Validation = {
  FieldSummary: FieldSummary,
  ProductSummary: ProductSummary
};

function ProductTable(Props) {
  var products = Props.products;
  var match = React.useState(function () {
        
      });
  var setSelectedProduct = match[1];
  var selectedProduct = match[0];
  var columns = [
    {
      title: "ID",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (product) {
          return React.createElement(ProductTable$Validation$FieldSummary, {
                      product: product,
                      getField: (function (p) {
                          return p.google_feed_id;
                        })
                    });
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "Title",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (product) {
          return React.createElement(ProductTable$Validation$FieldSummary, {
                      product: product,
                      getField: (function (p) {
                          return p.title;
                        })
                    });
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "Price",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (product) {
          return React.createElement(ProductTable$Validation$FieldSummary, {
                      product: product,
                      getField: (function (p) {
                          return p.price;
                        })
                    });
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "Sale_Price",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (product) {
          return React.createElement(ProductTable$Validation$FieldSummary, {
                      product: product,
                      getField: (function (p) {
                          return p.sale_price;
                        })
                    });
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "Validation",
      renderTitle: undefined,
      align: /* Center */1,
      render: (function (product) {
          return React.createElement(ProductTable$Validation$ProductSummary, {
                      product: product
                    });
        }),
      getClassName: undefined,
      getColSpan: undefined
    },
    {
      title: "",
      renderTitle: undefined,
      align: /* Left */0,
      render: (function (product) {
          return React.createElement(Button$MakerDs.make, {
                      onClick: (function (param) {
                          Curry._1(setSelectedProduct, (function (param) {
                                  return product;
                                }));
                        }),
                      outline: true,
                      text: "View"
                    });
        }),
      getClassName: undefined,
      getColSpan: undefined
    }
  ];
  var tmp;
  if (selectedProduct !== undefined) {
    var columns$1 = Belt_Array.map(getFields(selectedProduct), (function (param) {
            var value = param[1];
            return [
                    param[0],
                    React.createElement(ProductTable$Validation$FieldSummary, {
                          product: selectedProduct,
                          getField: (function (param) {
                              return value;
                            }),
                          details: true
                        })
                  ];
          }));
    tmp = React.createElement(ReactPortal.Portal, {
          children: React.createElement(Base$MakerDs.make, {
                children: null
              }, React.createElement("div", {
                    className: CSS$MakerDs.prefix("absolute inset-0 bg-mkr-black opacity-75"),
                    onClick: (function (param) {
                        Curry._1(setSelectedProduct, (function (param) {
                                
                              }));
                      })
                  }), React.createElement(Modal$MakerDs.make, {
                    children: React.createElement("div", {
                          className: CSS$MakerDs.prefix("flex flex-col gap-2 p-5 h-screen whitespace-nowrap overflow-auto")
                        }, React.createElement("div", {
                              className: CSS$MakerDs.prefix("flex gap-2 border-b border-gray-200 pb-2 mb-2")
                            }, React.createElement("div", {
                                  className: CSS$MakerDs.prefix("font-semibold"),
                                  style: {
                                    minWidth: "200px",
                                    width: "200px"
                                  }
                                }, "Validation: "), React.createElement("div", undefined, React.createElement(ProductTable$Validation$ProductSummary, {
                                      product: selectedProduct
                                    }))), Belt_Array.map(columns$1, (function (param) {
                                return React.createElement("div", {
                                            className: CSS$MakerDs.prefix("flex gap-2")
                                          }, React.createElement("div", {
                                                className: CSS$MakerDs.prefix("font-semibold"),
                                                style: {
                                                  minWidth: "200px",
                                                  width: "200px"
                                                }
                                              }, "" + param[0] + ": "), React.createElement("div", undefined, param[1]));
                              }))),
                    fullscreen: true,
                    overlay: false,
                    onClose: (function (param) {
                        Curry._1(setSelectedProduct, (function (param) {
                                
                              }));
                      }),
                    maxWidth: "800px",
                    position: "right"
                  }))
        });
  } else {
    tmp = null;
  }
  return React.createElement("div", undefined, React.createElement(Table$MakerDs.make, {
                  dataSource: products,
                  columns: columns,
                  fixed: true
                }), tmp);
}

var make = ProductTable;

export {
  getFields ,
  Validation ,
  make ,
}
/* react Not a pure module */
